import React from "react";

const s = {
  page: {
    minHeight: "calc(100vh - 72px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    background: "var(--bg-page)",
  },
  panel: {
    width: "100%",
    maxWidth: 560,
    textAlign: "center",
    background: "var(--bg-card)",
    border: "1px solid var(--border)",
    borderRadius: 14,
    boxShadow: "var(--dashboard-card-shadow)",
    overflow: "hidden",
  },
  logoWrap: {
    background: "#2d8641",
    padding: "34px 28px 30px",
  },
  logo: {
    maxWidth: 360,
    width: "100%",
    height: "auto",
    display: "block",
    margin: "0 auto",
  },
  content: {
    padding: "34px 28px 40px",
  },
  title: {
    fontFamily: "var(--font-heading)",
    fontSize: 30,
    fontWeight: 900,
    color: "var(--text-primary)",
    margin: "0 0 12px",
  },
  message: {
    fontSize: 18,
    lineHeight: 1.5,
    color: "var(--text-secondary)",
    margin: 0,
  },
};

export default function UnderConstructionSplash() {
  return (
    <div style={s.page}>
      <section style={s.panel}>
        <div style={s.logoWrap}>
          <img src="/images/logo.png" alt="SPEEDiagnostix" style={s.logo} />
        </div>
        <div style={s.content}>
          <h1 style={s.title}>Our Dashboard is under construction.</h1>
          <p style={s.message}>Please check back soon!</p>
        </div>
      </section>
    </div>
  );
}
